import { useRef } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { LoaderOverlay } from '@pocketlaw/tetris';
import { usePleditor } from 'shared/domains/documents';
import { Pleditor } from 'shared/domains/pleditor@next';
import * as Sentry from 'shared/domains/sentry';
import { useSandboxData } from './useSandboxData';
import { CriticalError } from '../../components/ErrorDialogs/CriticalError';
import { ReconnectingError } from '../../components/ErrorDialogs/ReconnectingError';
import { UnauthorizedError } from '../../components/ErrorDialogs/UnauthorizedError';
import { FeatureAvailability } from '../../components/FeatureAvailability';
import { documentState } from '../../documentState';
import { useIsLayoutReady } from '../../hooks/useIsLayoutReady';
import { BasePleditorStyles, PleditorContainer, PleditorSidebar, PleditorWrapper } from '../../styled';
import { RevisionHistoryEditor } from '../RTCPleditor/RevisionHistoryEditor';
import { useCompanyLogoUrl } from '../hooks';
export function SandboxPleditor(props) {
    const { toolbarItems, balloonToolbarItems, currentUser, featureAvailability, attachments } = props;
    const { setPleditor } = usePleditor();
    const companyLogoUrl = useCompanyLogoUrl();
    const commentSidebarRef = useRef(null);
    const editorContainerRef = useRef(null);
    const viewerContainerRef = useRef(null);
    const viewerEditorElementRef = useRef(null);
    const viewerSidebarContainerRef = useRef(null);
    const isLayoutReady = useIsLayoutReady();
    const { htmlBody, config, loading } = useSandboxData({
        currentUser,
        toolbarItems,
        balloonToolbarItems,
        featureAvailability,
        attachments,
        refs: {
            editorContainerRef: editorContainerRef.current,
            viewerContainerRef: viewerContainerRef.current,
            viewerEditorElementRef: viewerEditorElementRef.current,
            viewerSidebarContainerRef: viewerSidebarContainerRef.current,
            sidebarContainerRef: commentSidebarRef.current,
        },
    });
    const handleEditorReady = (editor) => {
        setPleditor('SandboxPleditor', editor);
        editor.data.set(htmlBody);
    };
    const handleEditorError = (e) => {
        documentState('error');
        Sentry.captureException(e, { tags: { feature: 'pleditor' } });
    };
    return (<LoaderOverlay label="Loading Sandbox Editor..." enabled={loading}>
      <FeatureAvailability />
      <BasePleditorStyles />
      <CriticalError />
      <ReconnectingError />
      <UnauthorizedError />
      {/* Editor view */}
      <PleditorWrapper ref={editorContainerRef}>
        <PleditorContainer $companyLogoUrl={companyLogoUrl}>
          {isLayoutReady && !loading && (<CKEditor editor={Pleditor} config={config} onReady={handleEditorReady} onError={handleEditorError}/>)}
          <PleditorSidebar ref={commentSidebarRef}/>
        </PleditorContainer>
      </PleditorWrapper>
      {/* Revision history editor view */}
      <RevisionHistoryEditor containerRef={viewerContainerRef} editorRef={viewerEditorElementRef} sidebarRef={viewerSidebarContainerRef}/>
    </LoaderOverlay>);
}
